module.exports = __webpack_public_path__ + "static/media/initialClass.033bf05.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/initialClass.mp4
// module id = 771
// module chunks = 2 7 38 50